import React, { useState } from "react";
import { Box, Typography, Button, Paper, Alert, Container } from "@mui/material";
import { EmailOutlined as EmailIcon } from "@mui/icons-material";

export default function EmailVerificationSend(props) {
    const { onResendEmailClicked, onSignOutClicked } = props;
    const [status, setStatus] = useState("");

    const handleResend = async () => {
        try {
            await onResendEmailClicked();
            setStatus("Email resent successfully!");
        } catch (e) {
            setStatus("Failed to resend email. Please try again.");
        }
    };

    const handleSignOut = async () => {
        try {
            await onSignOutClicked();
        } catch (err) {
            console.warn("Sign out failed from email verification screen:", err);
        }
    };

    return (
        <Container component="main" maxWidth="sm" sx={{ mt: 8 }}>
            <Paper elevation={3} sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <EmailIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
                
                <Typography component="h1" variant="h5" gutterBottom>
                    Verify Your Email
                </Typography>
                
                <Typography variant="body1" align="center" sx={{ mb: 3 }}>
                    We've sent a verification email to you. Please check your inbox and click the link to verify your account.
                </Typography>

                {status && (
                    <Alert 
                        severity={status.includes("success") ? "success" : "error"} 
                        sx={{ width: '100%', mb: 2 }}
                    >
                        {status}
                    </Alert>
                )}

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={handleResend}
                    >
                        Resend Verification Email
                    </Button>
                    
                    <Button
                        fullWidth
                        variant="outlined"
                        onClick={handleSignOut}
                    >
                        Sign Out
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
}
